import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'pollCalculatePercentage' })
export class PollCalculatePercentagePipe implements PipeTransform {
  transform(votes: number, totalVotes: number): number {
    if (votes && totalVotes !== 0) {
      return Math.floor((votes / totalVotes) * 100);
    }
    return 0;
  }
}
